import { render, staticRenderFns } from "./FolderItem.vue?vue&type=template&id=2714b099"
import script from "./FolderItem.vue?vue&type=script&lang=js"
export * from "./FolderItem.vue?vue&type=script&lang=js"
import style0 from "./FolderItem.vue?vue&type=style&index=0&id=2714b099&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports